import React from "react";

function Archives() {
  return <div>Archives</div>;
}

export default Archives;
